export interface AppUser {
  username: string,
  token: string,
  isAuthenictated: boolean,
  isDefaultPassword: boolean,
  roles: string[],
};

export enum PLACE_OF_BUSSINESS_TYPE {
    DEPOSIT, // For the places of businnes deposits
    INTERMEDARY // For the cars inventory
};

export enum TransactionType {
    In,
    Out,
    InventoryTransfer
};

